import PdfBook from "components/catalog/PdfBook";

import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchCatalog } from "store/catalog/catalog.slice";
import { LoadingOutlined } from "@ant-design/icons";

const CatalogPage = () => {
  const { catalog, is_fetch } = useSelector((store: any) => store.catalog);
  const dispatch: any = useDispatch();

  useEffect(() => {
    dispatch(fetchCatalog());
  }, [dispatch]);
  if (!is_fetch) {
    return <LoadingOutlined />;
  }
  return (
    <div className="Page">
      <div className="Page-Content Page-Content-Center">
        {/* // aspectRatio = 0.9215915740198947 */}
        {/* loading */}
        <PdfBook
          pages={catalog.pages}
          pageNumber={catalog.num_pages}
          imgWidth={300}
          imgHeight={300 / catalog.aspect_ration}
          pdfUrl={catalog.file_url}
        />
      </div>
    </div>
  );
};
export default CatalogPage;
